import '../webapp.css';
import { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { getCurrency } from '../functions/classes';
import { PiInfinityBold, PiHeadsetBold, PiSparkleBold, PiSealCheckBold } from 'react-icons/pi';

const PremiumPopup = ({ onGetPremium }) => {
  const [currency, setCurrency] = useState('CA$');

  useEffect(() => {
    const fetchCurrency = async () => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;
      const db = getFirestore();
      const userDocRef = doc(db, 'companyUsers', user.uid);
      const userSnap = await getDoc(userDocRef);
      setCurrency(userSnap.exists() ? getCurrency(userSnap.data()) : 'CA$');
    };
    fetchCurrency();
  }, []);

  return (
    <div className="modal-overlay">
      <div className="popup" >
        <div className="premium-first premium-col">
          <h2>Go unlimited—Unlock Premium</h2>
          <p className="description">
            You've hit your free 10 shift limit, but why stop there?<br/>Get Premium now and enjoy:
          </p>
          <ul>
            <li><PiInfinityBold />Unlimited Shift Coverage</li>
            <li><PiSealCheckBold />Unlimited Onboarding</li>
            <li><PiSparkleBold />Unlimited KierepAI Queries</li>
            <li><PiHeadsetBold />Priority Support</li>
          </ul>
          <div className="price">
            <p className="price-num">{currency}499</p>
            <p className="billing-cycle">monthly</p>
          </div>
          <button className="full-button maroon" onClick={onGetPremium}>Go Premium</button>
        </div>
        <div className="premium-col">
          <img src={require('../assets/premium.jpg')} alt="Premium-image"/>
        </div>
      </div>
    </div>
  );
};

export default PremiumPopup;
